import React from 'react';
export const ApplicationStatus = ({
  data
}) => {
  return <div className="space-y-4" data-id="element-290">
      <div data-id="element-291">
        <h3 className="text-sm text-gray-500 mb-1" data-id="element-292">Application Status</h3>
        <div className="flex items-center" data-id="element-293">
          <div className="w-3 h-3 bg-[#5c5cf5] rounded-full mr-2" data-id="element-294"></div>
          <span className="font-medium" data-id="element-295">{data.applicationStatus}</span>
        </div>
      </div>
      <div data-id="element-296">
        <h3 className="text-sm text-gray-500 mb-1" data-id="element-297">Ownership</h3>
        <div className="flex flex-col" data-id="element-298">
          {data.applicants.map((applicant, index) => <div key={index} className="flex justify-between" data-id="element-299">
              <span data-id="element-300">{applicant.name}</span>
              <span data-id="element-301">{applicant.ownership}</span>
            </div>)}
        </div>
      </div>
      <div data-id="element-302">
        <h3 className="text-sm text-gray-500 mb-1" data-id="element-303">Business Structure</h3>
        <p data-id="element-304">{data.businessStructure}</p>
      </div>
    </div>;
};